import { JourneyLegsApiService, AssistanceDetailsService } from '@common/ApiService'
import journeyLegSearchParams from '@utils/journey-leg-search-params'
import paginationHeaders from '@/src/utils/pagination-headers'

const JOURNEY_LEGS_SUCCESS = 'JOURNEY_LEGS_SUCCESS'
const JOURNEY_LEGS_ERROR = 'JOURNEY_LEGS_ERROR'
const JOURNEY_LEGS_PROGRESS = 'JOURNEY_LEGS_PROGRESS'
const JOURNEY_LEGS_CLEAR = 'JOURNEY_LEGS_CLEAR'
const UPDATE_PAGINATION = 'UPDATE_PAGINATION'
const UPDATE_PAGE = 'UPDATE_PAGE'
const UPDATE_BOOKING_LEG_STATUS = 'UPDATE_BOOKING_LEG_STATUS'

export const state = {
  journey_legs: [],
  pagination: {},
  errors: {},
  progress: '',
}

export const getters = {}

export const mutations = {
  [JOURNEY_LEGS_SUCCESS](state, data) {
    state.journey_legs = data
    return state
  },

  [UPDATE_PAGINATION](state, response) {
    state.pagination = paginationHeaders(response)
    return state
  },

  [JOURNEY_LEGS_PROGRESS](state, progress) {
    state.progress = progress
    return state.progress
  },

  [UPDATE_PAGE](state, page) {
    state.pagination = { ...state.pagination, page }
    return state.pagination
  },

  [JOURNEY_LEGS_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state
  },

  [JOURNEY_LEGS_CLEAR](state) {
    state.journey_legs = {}
    return state
  },

  [UPDATE_BOOKING_LEG_STATUS](_, query) {
    query.rootState.bookings.booking.journeys.forEach((booking) => {
      booking.legs.forEach((leg) => {
        if (leg.id === query.leg.id) {
          leg.status = query.leg.status
        }
      })
    })
  },
}

export const actions = {
  fetchJourneyLegs({ commit }, query) {
    if (query.page) {
      commit(UPDATE_PAGE, query.page)
    }
    return new Promise((resolve) => {
      commit(JOURNEY_LEGS_PROGRESS, 'search_loading')
      return JourneyLegsApiService.query(journeyLegSearchParams(query))
        .then((response) => {
          commit(JOURNEY_LEGS_SUCCESS, response.data)
          commit(UPDATE_PAGINATION, response)
          commit(JOURNEY_LEGS_PROGRESS, 'journey_legs_success')
          resolve(response.data)
        })
        .catch((error) => commit(JOURNEY_LEGS_ERROR, error))
    })
  },

  updateJourneyLegStatus({ commit, rootState }, query) {
    commit(JOURNEY_LEGS_PROGRESS, 'update_loading')
    return JourneyLegsApiService.updateStatus(query.id, {
      status: query.status,
      incomplete_reasons: query.incomplete_reasons ?? null,
      validation_reminder: query.validation_reminder ?? null,
      validation_reminder_enabled: query.validation_reminder_enabled ?? null,
    })
      .then((response) => {
        commit(JOURNEY_LEGS_SUCCESS, response.data)
        commit('UPDATE_BOOKING_LEG_STATUS', {
          rootState: rootState,
          leg: response.data,
        })
      })
      .catch((error) => commit(JOURNEY_LEGS_ERROR, error))
  },

  revertToPending({ commit, rootState }, { assistanceDetailId }) {
    commit(JOURNEY_LEGS_PROGRESS, 'revert_loading')

    return AssistanceDetailsService.unresolve(assistanceDetailId)
      .then((response) => {
        commit(JOURNEY_LEGS_SUCCESS, response.data)
        commit('UPDATE_BOOKING_LEG_STATUS', {
          rootState: rootState,
          leg: response.data,
        })
        commit(JOURNEY_LEGS_PROGRESS, 'revert_success')
        return response.data
      })
      .catch((error) => {
        commit(JOURNEY_LEGS_ERROR, error)
        throw error
      })
  },
}
